import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../../../redux/settings/selectors';
import storePersist from '../../../../../../../redux/storePersist';
import { deepCopy } from '../../../../../../../common/services/common.service';
import { settings } from '../../../../../../../redux/settings/actions';
import UploadFiles from '../../../../../../../models/UploadFile';
import PageLoader from '../../../../../../../components/PageLoader';
import BrandMappingComponent from '../components/brand-mapping.component';
import { useSelector } from 'react-redux';
import { selectBrandMappingsQueryItems } from '../../../../../../../redux/brand-mappings/selector';
import { brandMappings as cmsBrandMappings } from '../../../../../../../redux/brand-mappings/action';


let currentChange: any = {}
const OWNER_TYPE_ACCOUNT = 68

const DBABrandMapping = ({ onSubmit, cardDetailInfo }: any) => {

    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { dbaId, id } = useParams()
    const { getUploadFiles } = useAppSelector(selectCurrent)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [logoFiles, setLogoFiles] = useState<any>([])
    const [favFiles, setFavFiles] = useState<any>([])
    const brandMappingsQueryData = useSelector(selectBrandMappingsQueryItems)
    const librariesItems = storePersist?.get("library")?.current;
    const [brandMappings, setBrandMappings] = useState<any>([])
    const [openFile, setOpenFile] = useState<any>([]);
    const [openConfirmationFile, setOpenConfirmationFile] = React.useState(false);
    const [openConfirmationLogoFile, setOpenConfirmationLogoFile] = React.useState(false);
    const [openConfirmationFavFile, setOpenConfirmationFavFile] = React.useState(false);
    const [openImageFile, setOpenImageFile] = useState<any>([]);



    const fetchBrandMappingsQueryById = () => {
        dispatch(cmsBrandMappings.query({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/brand-mappings/query`,
            entity: 'cmsBrandMappings',
            jsonData: {
                Records: [
                    {
                        Id: Number(id),
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleFormLogoItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
        const items = deepCopy(cardValue.Logos);
        items[idx] = { ...items[idx], [field]: value };
        setLogoFiles(items);
        const updatedCardValue = [...brandMappings];
        updatedCardValue[idx1] = { ...cardValue, Logos: items };
        setBrandMappings(updatedCardValue);
    }

    const handleFormFavItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
        const items = deepCopy(cardValue.Favicons);
        items[idx] = { ...items[idx], [field]: value };
        setFavFiles(items);
        const updatedCardValue = [...brandMappings];
        updatedCardValue[idx1] = { ...cardValue, Favicons: items };
        setBrandMappings(updatedCardValue);
    }

    const handleFormItemBrandChange: any = ({ value, field, idx }: any) => {
        const items = deepCopy(brandMappings);
        let item = items[idx];
        item = { ...item, [field]: value }
        items[idx] = item;
        currentChange = { value, field, idx }
        setBrandMappings(items);
    }

    const handleClose = () => {
        if (openConfirmationFile) {
            setOpenConfirmationFile(false)
        } else if (openConfirmationLogoFile) {
            setOpenConfirmationLogoFile(false)
        } else if (openConfirmationFavFile) {
            setOpenConfirmationFavFile(false)
        }
        dispatch(settings.set({ getUploadFiles: 'close' }))
    }

    const addNewRow = ({ selectedBrandsArg }: any) => {
        const localSelectedBrands = deepCopy(selectedBrandsArg || [])
        const newsBrand = {
            Id: 0,
            Name: '',
            Description: '',
            Logos: [
                {
                    Url: '',
                    Size: '',
                    Background: '',
                }
            ],
            Favicons: [
                {
                    Url: '',
                    Size: '',
                    Background: '',
                }
            ],
            Branding: {
                Primary: {},
                Secondary: {},
                Tertiary: {},
                Ghost: {}
            }
        }
        if (localSelectedBrands.length === 0 ||
            localSelectedBrands[localSelectedBrands?.length - 1]?.Name !== ''
        ) {
            localSelectedBrands?.push(newsBrand);
        }

        return localSelectedBrands
    }

    const addNewLogoFilesRow = ({ selectedLogoFilesArg, brandMapping, idx, idx1 }: any) => {
        const localSelectedlogo = deepCopy(selectedLogoFilesArg || [])
        const newSelectedLogo = {
            Url: '',
            Size: '',
            Background: '',
        }

        if (localSelectedlogo.length === 0 ||
            brandMapping[idx1]?.Logos[brandMapping[idx1].Logos?.length - 1]?.Url !== ''
        ) {

            brandMapping[idx1]?.Logos?.push(newSelectedLogo)
        }

        return localSelectedlogo
    }

    const addNewFavFilesRow = ({ selectedFavFilesArg, brandMapping, idx, idx1 }: any) => {
        const localSelectedfav = deepCopy(selectedFavFilesArg || [])
        const newSelectedFav = {
            Url: '',
            Size: '',
            Background: '',
        }

        if (localSelectedfav.length === 0 ||
            brandMapping[idx1]?.Favicons[brandMapping[idx1].Favicons?.length - 1]?.Url !== ''
        ) {

            brandMapping[idx1]?.Favicons?.push(newSelectedFav)
        }

        return localSelectedfav
    }

    const setCombinationLogoInfo = async () => {
        let localSelectedLogo = deepCopy(logoFiles)
        localSelectedLogo.splice(
            currentChange.idx,
            1,
            { ...localSelectedLogo[currentChange.idx] }
        );
        localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: localSelectedLogo, brandMapping: brandMappings, idx1: currentChange.idx });
        currentChange.field = 'UrlDONE'
        setLogoFiles(localSelectedLogo)
    }

    const setCombinationFavInfo = async () => {
        let localSelectedFav = deepCopy(favFiles)
        localSelectedFav.splice(
            currentChange.idx,
            1,
            { ...localSelectedFav[currentChange.idx] }
        );
        localSelectedFav = addNewFavFilesRow({ selectedFavFilesArg: localSelectedFav, brandMapping: brandMappings, idx1: currentChange.idx });
        currentChange.field = 'UrlDONE'
        setFavFiles(localSelectedFav)
    }

    const setCombinationBrandInfo = async () => {
        let localSelectedbrands = deepCopy(brandMappings)
        localSelectedbrands.splice(
            currentChange.idx,
            1,
            { ...localSelectedbrands[currentChange.idx] }
        );
        localSelectedbrands = addNewRow({ selectedBrandsArg: localSelectedbrands });
        currentChange.field = 'NameDONE'
        setBrandMappings(localSelectedbrands)
    }

    useEffect(() => {
        if (currentChange.field === 'Url') {
            setCombinationLogoInfo()
        }
    }, [currentChange.field, currentChange.idx])

    useEffect(() => {
        if (currentChange.field === 'Url') {
            setCombinationFavInfo()
        }
    }, [currentChange.field, currentChange.idx])

    // useEffect(() => {
    //     if (currentChange.field === 'Name') {
    //         setCombinationBrandInfo()
    //     }
    // }, [brandMappings])

    const handleLogoSubmit = (data: any) => {
        const newLogoFiles = [...logoFiles];
        const logosArray = brandMappings[currentChange.idx1]?.Logos;
        logosArray[currentChange.idx].Url = data;
        const localSelectedLogo = addNewLogoFilesRow({
            selectedLogoFilesArg: newLogoFiles,
            brandMapping: brandMappings,
            idx: currentChange.idx,
            idx1: currentChange.idx1,
            data: data
        });
        setLogoFiles(localSelectedLogo)
    }

    const changeLogoImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
        dispatch(settings.set({ getUploadFiles: 'open' }))
        setOpenConfirmationLogoFile(true)
        setOpenImageFile({
            currentFileSrc: brandMaping[idx1]?.Logos[idx][templateField],
            folder: 'Organizationunit',
            type: fileType
        })
        currentChange = { idx, templateField, idx1 }
    }

    const changeFavImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
        dispatch(settings.set({ getUploadFiles: 'open' }))
        setOpenConfirmationFavFile(true)
        setOpenImageFile({
            currentFileSrc: brandMaping[idx1]?.Favicons[idx][templateField],
            folder: 'Organizationunit',
            type: fileType
        })
        currentChange = { idx, templateField, idx1 }
    }

    const handleFavSubmit = (data: any) => {
        const newfavFiles = [...favFiles];
        const favsArray = brandMappings[currentChange?.idx1]?.Favicons;
        favsArray[currentChange?.idx].Url = data;
        const localSelectedFav = addNewFavFilesRow({
            selectedFavFilesArg: newfavFiles,
            brandMapping: brandMappings,
            idx: currentChange.idx,
            idx1: currentChange.idx1,
            data: data
        });

        setFavFiles(localSelectedFav)
    }

    useEffect(() => {
        if (!brandMappingsQueryData?.result?.items) return;

        const configItem = brandMappingsQueryData.result.items.Configurations;
        const brandMappingsArr = configItem ? [configItem] : [];

        const brandData = brandMappingsArr.map((item: any) => {
            const logos = item?.Logos?.map((logoItem: any) => ({
                Url: logoItem.Url,
                Size: logoItem.Size,
                Background: logoItem.Background,
            })) || [];

            const favicons = item?.Favicons?.map((favItem: any) => ({
                Url: favItem.Url,
                Size: favItem.Size,
                Background: favItem.Background,
            })) || [];

            // ✅ Always add an extra empty row for Logos and Favicons
            logos.push({ Url: '', Size: '', Background: '' });
            favicons.push({ Url: '', Size: '', Background: '' });

            return {
                Id: brandMappingsQueryData.result.items.Id,
                Name: brandMappingsQueryData.result.items.Name,
                OwnerId: brandMappingsQueryData.result.items.OwnerId,
                OwnerType: brandMappingsQueryData.result.items.OwnerType,
                OwnerTypeId: brandMappingsQueryData.result.items.OwnerTypeId,
                Description: brandMappingsQueryData.result.items.Description,
                Theme: brandMappingsQueryData.result.items.Theme,
                PrimaryColor: item?.Branding?.Primary?.Color,
                PrimaryBackgroundColor: item?.Branding?.Primary?.BackgroundColor,
                PrimaryBackgroundImage: item?.Branding?.Primary?.BackgroundImage,
                SecondaryColor: item?.Branding?.Secondary?.Color,
                SecondaryBackgroundColor: item?.Branding?.Secondary?.BackgroundColor,
                SecondaryBackgroundImage: item?.Branding?.Secondary?.BackgroundImage,
                TertiaryColor: item?.Branding?.Tertiary?.Color,
                TertiaryBackgroundColor: item?.Branding?.Tertiary?.BackgroundColor,
                TertiaryBackgroundImage: item?.Branding?.Tertiary?.BackgroundImage,
                GhostColor: item?.Branding?.Ghost?.Color,
                GhostBackgroundColor: item?.Branding?.Ghost?.BackgroundColor,
                GhostBackgroundImage: item?.Branding?.Ghost?.BackgroundImage,
                ShortDescription: brandMappingsQueryData.result.items.Stories?.ShortDescription,
                LongDescription: brandMappingsQueryData.result.items.Stories?.LongDescription,
                SearchEngineFriendlyPageName: brandMappingsQueryData.result.items.Stories?.SEO?.SearchEngineFriendlyPageName,
                MetaDescription: brandMappingsQueryData.result.items.Stories?.SEO?.MetaDescription,
                MetaKeywords: brandMappingsQueryData.result.items.Stories?.SEO?.MetaKeywords,
                MetaTitle: brandMappingsQueryData.result.items.Stories?.SEO?.MetaTitle,
                Logos: logos,
                Favicons: favicons,
                Branding: item?.Branding || {},
            };
        });

        // ✅ Set the updated brand mappings (with logo/favicon extra row)
        setBrandMappings(brandData);



        // ✅ Directly map logos and favicons for table-level state
        const updatedLogo = brandData.map((brand) => brand.Logos);
        const updatedFav = brandData.map((brand) => brand.Favicons);
        setLogoFiles(updatedLogo);
        setFavFiles(updatedFav);
    }, [brandMappingsQueryData]);




    const handleFormSubmit = async (event: any) => {
        event.preventDefault();


        const brandData: any = brandMappings.map((item: any) => {
            if (item?.Logos?.length) {
                item.Logos.splice(item.Logos.length - 1, 1);
            }
            if (item?.Favicons?.length) {
                item.Favicons.splice(item.Favicons.length - 1, 1);
            }
            const itemData = {
                Id: item?.Id,
                OwnerType: item?.OwnerType,
                OwnerTypeId: item?.OwnerTypeId,
                OwnerId: item?.OwnerId,
                Name: item?.Name,
                Description: item?.Description,
                Theme: item?.Theme,
                MappedEntities: [
                    {
                        Id: 0,
                        OwnerTypeId: 1033,
                        OwnerTypeName: "DBA",
                        OwnerId: dbaId,
                        IsApproved: true,
                    }
                ],
                Configurations: {
                    Logos: item?.Logos?.map((logoItem: any) => {
                        return {
                            Url: logoItem.Url,
                            Size: logoItem.Size,
                            Background: logoItem.Background,
                        };
                    }),
                    Favicons: item?.Favicons?.map((favItem: any) => {
                        return {
                            Url: favItem.Url,
                            Size: favItem.Size,
                            Background: favItem.Background,
                        };
                    }),
                    Branding: {
                        Primary: {
                            Color: item?.PrimaryColor,
                            BackgroundColor: item?.PrimaryBackgroundColor,
                            BackgroundImage: item?.PrimaryBackgroundImage
                        },
                        Secondary: {
                            Color: item?.SecondaryColor,
                            BackgroundColor: item?.SecondaryBackgroundColor,
                            BackgroundImage: item?.SecondaryBackgroundImage
                        },
                        Tertiary: {
                            Color: item?.TertiaryColor,
                            BackgroundColor: item?.TertiaryBackgroundColor,
                            BackgroundImage: item?.TertiaryBackgroundImage
                        },
                        Ghost: {
                            Color: item?.GhostColor,
                            BackgroundColor: item?.GhostBackgroundColor,
                            BackgroundImage: item?.GhostBackgroundImage
                        },

                    },

                },
                Stories: {
                    ShortDescription: item?.ShortDescription,
                    LongDescription: item?.LongDescription,
                    SEO: {
                        SearchEngineFriendlyPageName: item?.SearchEngineFriendlyPageName,
                        MetaDescription: item?.MetaDescription,
                        MetaKeywords: item?.MetaKeywords,
                        MetaTitle: item?.MetaTitle
                    }
                },
            }
            return itemData
        })
        if (Number(id) > 0) {
            await dispatch(cmsBrandMappings.resetAction({ actionType: 'update' }))
            await dispatch(cmsBrandMappings.update({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/brand-mappings`,
                entity: 'cmsBrandMappings',
                jsonData:
                {
                    Records: brandData
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(cmsBrandMappings.resetAction({ actionType: 'create' }))
            await dispatch(cmsBrandMappings.create({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/brand-mappings`,
                entity: 'cmsBrandMappings',
                jsonData:
                {
                    Records: brandData
                }
            })).then(() => {
                back()
            })
        }
    }

    useEffect(() => {

    }, [brandMappings]);

    useEffect(() => {


        if (Number(id) > 0) {
            fetchBrandMappingsQueryById()
            setIsLoading(false)
        } else {
            const localSelectedBrands = addNewRow({ selectedBrandsArg: brandMappings });
            setBrandMappings(localSelectedBrands)
            const localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: logoFiles, brandMapping: brandMappings, idx1: 0 });
            setLogoFiles(localSelectedLogo)

            setIsLoading(false)
        }
    }, [])




    const back = () => {
        navigate(-1)
    }
    const formatWebpagesListData = (data: any) => {
        return _.map(data, (product: any) => {
            const item = {
                Id: product?.Id,
                WebpageName: `${product?.Name} : ${product?.AccountName}`,
            };
            return item
        });
    };
    return (
        <>
            {getUploadFiles == 'open' && openConfirmationLogoFile &&
                <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
                    folder={openImageFile?.folder}
                    handleClose={handleClose}
                    handleFilesSubmit={handleLogoSubmit}
                    type={openImageFile?.type}
                    ownerId={Number(id)}
                />
            }
            {getUploadFiles == 'open' && openConfirmationFavFile &&
                <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
                    folder={openImageFile?.folder}
                    handleClose={handleClose}
                    handleFilesSubmit={handleFavSubmit}
                    type={openImageFile?.type}
                    ownerId={Number(id)}
                />
            }
            {brandMappingsQueryData?.isLoading ? <PageLoader /> :
                <BrandMappingComponent
                    handleClose={handleClose}
                    onFormItemBrandChange={handleFormItemBrandChange}
                    logoFiles={logoFiles}
                    changeFavImage={changeFavImage}
                    onFormLogoItemChange={handleFormLogoItemChange}
                    faviconSize={librariesItems?.FaviconSize}
                    changeLogoImage={changeLogoImage}
                    logoBackground={librariesItems?.LogoBackground}
                    brandMappings={brandMappings}
                    onFormFavItemChange={handleFormFavItemChange}
                    handleFormSubmit={handleFormSubmit}
                    back={back}
                />
            }
        </>
    )
}

export default DBABrandMapping;